module.exports = __webpack_public_path__ + "img/stickWand.6c19335b.jpg";